import type { SerializedNative, SerializedToken } from "@eulerxyz/core-sdk"
import {
  type TransactionItemUnion,
  TransactionLabel,
} from "./baseTransactionTypes"
import type { SwapTransactionItem } from "./swapTransactionTypes"
import { SwapSingleTransactionItem } from "./swapTransactionTypes"
import { SwapVerifierTransaction } from "./swapVerifierTransactionTypes"
import type { VaultTransactionItem } from "./vaultTransactionTypes"

//TODO: think if its better to be separated in different files or inline with the types?
export function isSwapTransaction(
  transaction: TransactionItemUnion,
): transaction is SwapTransactionItem {
  return (
    transaction.label === TransactionLabel.SWAP ||
    transaction.label === TransactionLabel.SWAP_MULTICALL
  )
}

// @deprecated this is not used anymore
export function isSwapOnHandlerTransaction(
  transaction: TransactionItemUnion,
): transaction is SwapSingleTransactionItem {
  return transaction.label === TransactionLabel.SWAP
}

export function isSwapVerifierTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is SwapVerifierTransaction {
  return (
    transaction?.label === TransactionLabel.SWAP_VERIFIER_SKIM_MIN ||
    transaction?.label === TransactionLabel.SWAP_VERIFIER_DEBT_MAX
  )
}
export function isSkimVaultTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is SwapVerifierTransaction {
  return transaction?.label === TransactionLabel.SKIM
}
export function isVaultTransaction(
  transaction: TransactionItemUnion,
): transaction is VaultTransactionItem {
  return (
    //TODO: think if its better categorization
    transaction.label === TransactionLabel.BORROW ||
    transaction.label === TransactionLabel.DEPOSIT ||
    transaction.label === TransactionLabel.REPAY ||
    transaction.label === TransactionLabel.REPAYWITHSHARES ||
    transaction.label === TransactionLabel.WITHDRAW ||
    transaction.label === TransactionLabel.REDEEM ||
    transaction.label === TransactionLabel.TRANSFER ||
    transaction.label === TransactionLabel.ENABLE_BALANCE_FORWARDER ||
    transaction.label === TransactionLabel.DISABLE_BALANCE_FORWARDER ||
    transaction.label === TransactionLabel.SKIM ||
    transaction.label === TransactionLabel.SKIM_IN ||
    transaction.label === TransactionLabel.CONVERT_FEES
  )
}

export function isSerializedToken(
  asset?: SerializedToken | SerializedNative,
): asset is SerializedToken {
  return Boolean(asset && !asset.isNative)
}
